<div class="modal-body">
    <div style="text-align: center">
        <div>
            <span>&nbsp;&nbsp;{{ message }}</span>
        </div>
        <div class="block-spinner-bar" style="margin-bottom: 10px">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</div>
